// @ts-check

import React from "react";
// @ts-ignore
import worker from "workerize-loader!./worker"; // eslint-disable-line

let { getCurrentAmount } = worker();

let numberFmt = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

function RealtimeSal(
  /** @type {{ items: { sal: number, date: number, beforeWeekends: boolean }[] }} */
  { items },
) {
  let [amounts, setAmounts] = React.useState([0]);
  let [title, setTitle] = React.useState("");
  let amountsRef = React.useRef(amounts);
  amountsRef.current = amounts;

  React.useEffect(() => {
    let stop = false;
    /** @type {number} */
    let req;

    let calc = async () => {
      const sals = await Promise.allSettled(
        items.map(({ sal, date, beforeWeekends }) =>
          getCurrentAmount(sal, date, beforeWeekends),
        ),
      );

      /** @type {number[]} */
      let amounts = [];
      for (const sal of sals) {
        amounts.push(sal.status === "fulfilled" ? sal.value : 0);
      }
      setAmounts(amounts);

      if (stop) return;
      req = requestAnimationFrame(calc);
    };
    calc();

    return () => {
      stop = true;
      cancelAnimationFrame(req);
    };
  }, [items]);

  React.useEffect(() => {
    let timer = setInterval(() => {
      setTitle(
        amountsRef.current.map((amount) => numberFmt.format(amount)).join("\n"),
      );
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const total = amounts.reduce((a, b) => a + b, 0);

  if (!total) return null;

  return (
    <div title={title}>
      <code>{numberFmt.format(total)}</code>
    </div>
  );
}

function App() {
  return (
    <div style={{ padding: 8 }}>
      <RealtimeSal
        items={[
          { sal: 110_000_000, date: 4, beforeWeekends: false },
          { sal: 44_000_000, date: 19, beforeWeekends: false },
          { sal: 61_000_000, date: 1, beforeWeekends: false },
          { sal: 49_500_000, date: 1, beforeWeekends: false },
        ]}
      />
    </div>
  );
}

export default App;
